export default __webpack_public_path__ + "static/media/FacilityTypeIcon.6d926c2e.svg";